const doc = [({"zh_cn":({"adminConstantHotelBillingType":({"free":"免费计划", "paid":"付费计划"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;